(function(){
    'use strict'

    angular
    .module('app.unidades')
    .controller('EditarUnidad', EditarUnidad);

    EditarUnidad.$inject = ['$scope', '$animationsSrv', '$routeParams','UnidadesService', 'logger', '$location'];

    function EditarUnidad($scope, $animationsSrv, $routeParams, UnidadesService, logger, $location) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.unidadId = $routeParams.id ? $routeParams.id : 0;

        getUnidad();

        function getUnidad(){

            if(vm.unidadId != 0){
                var promise = UnidadesService.getById(vm.unidadId);

                promise
                .then(function(unidad){
                    vm.unidad = unidad;
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener la unidad: ' + error.data.Message);
                            break;
                    }
                });               
            }

        };

        vm.save = function(){

            $scope.submitted = true;

            if($scope.unidadForm.$valid){
                if(!vm.unidad.id){
                    saveUnidad();
                }
                else if($scope.unidadForm.$dirty){
                    updateUnidad();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function saveUnidad() {
            var promise = UnidadesService.save(vm.unidad);
            
            promise
            .then(function(response){
                logger.success('Unidad creada con éxito.');
                clearUnidadData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear la unidad: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateUnidad(){
            var promise = UnidadesService.update(vm.unidad);
            
            promise
            .then(function(response){
                logger.success('Unidad modificada con éxito.');
                $location.path('/unidades');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar la unidad: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearUnidadData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.unidad = {};
            // Set back to pristine.
            $scope.unidadForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.unidadForm.$setUntouched();
        };

    }
})();